const settings = {
  API_BASE_URL: "https://salestvsapp.truetab.ai/api/v2",
  // API_BASE_URL: "http://192.168.0.104:8000/api/v2",
};
export default settings;
